import React from "react";

// onCancel is the proper way to close the popup: pass a function from the
// parent, e.g. <Step1 ... onCancel={() => setShowSignup(false)} />
// If it is not passed, the button falls back to closing the modal by itself
// (Bootstrap API first, then by hiding the modal markup directly).
const Step1 = ({ formData, setFormData, nextStep, prevStep, onCancel }) => {
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCancel = (e) => {
    // 1) Preferred: the parent tells us how to close the popup
    if (typeof onCancel === "function") {
      onCancel();
      return;
    }

    const modalEl = e.currentTarget.closest(".modal");
    if (!modalEl) return;

    // 2) Bootstrap modal opened via the Bootstrap JS API
    const bs = typeof window !== "undefined" ? window.bootstrap : null;
    if (bs && bs.Modal) {
      bs.Modal.getOrCreateInstance(modalEl).hide();
      return;
    }

    // 3) Last resort: hide the modal markup directly and clean up the backdrop
    modalEl.classList.remove("show");
    modalEl.style.display = "none";
    modalEl.setAttribute("aria-hidden", "true");
    modalEl.removeAttribute("aria-modal");
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");
  };

  return (
    <div className="step1">
      <div className="left-icon1">
        <button type="button" className="backbutton" onClick={prevStep}>
          <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
        </button>
      </div>

      {/* Cancel — top right corner, small round button */}
      <button
        type="button"
        className="cancelbutton"
        aria-label="Cancel"
        title="Cancel"
        onClick={handleCancel}
        style={{
          position: "absolute",
          top: 18,
          right: 24,
          width: 32,
          height: 32,
          minWidth: 32,
          minHeight: 32,
          flex: "none",
          boxSizing: "border-box",
          padding: 0,
          margin: 0,
          borderRadius: "50%",
          border: "none",
          background: "#f4f4f4",
          color: "#000",
          fontSize: 14,
          lineHeight: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          zIndex: 5,
        }}
      >
        <i className="fa fa-times" aria-hidden="true"></i>
      </button>

      <div className="icon-blk text-center">
        <img src="images/profile-icon.svg" alt="Profile" />
      </div>
      <div className="form-basic">
        <h5 className="modal-title">Your Name</h5>
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            placeholder="First name"
          />
        </div>
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            placeholder="Last name"
          />
        </div>
        <div className="modal-footer border-0 justify-content-center p-0 footer-modal mt-4">
          <button
            type="button"
            className="py-2 btn-filled"
            onClick={nextStep}
            disabled={!formData.firstName || !formData.lastName}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step1;